module.exports = __webpack_public_path__ + "img/dash2-light.3605474c.png";